import { render, staticRenderFns } from "./CustomModalWrapper.vue?vue&type=template&id=265419e6&"
import script from "./CustomModalWrapper.vue?vue&type=script&lang=js&"
export * from "./CustomModalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CustomModalWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports